import { Fragment } from 'react';
import { scaleLinear } from 'd3-scale';
import { useChartContext, useTheme, useSparkLine, XMLNS, STROKE_DOT_ARRAY_WIDTH, LineSeries } from '@shopify/polaris-viz-core';
import { useThemeSeriesColors } from '../../hooks/useThemeSeriesColors.js';
import styles from './SparkLineChart.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const SVG_MARGIN = 2;
function Chart({
  data,
  dimensions,
  accessibilityLabel,
  offsetLeft = 0,
  offsetRight = 0
}) {
  const {
    theme
  } = useChartContext();
  const selectedTheme = useTheme();
  const seriesColors = useThemeSeriesColors(data, selectedTheme);
  const {
    width,
    height
  } = dimensions !== null && dimensions !== void 0 ? dimensions : {
    height: 0,
    width: 0
  };
  const {
    minXDomain,
    maxXDomain,
    yScale
  } = useSparkLine({
    data,
    height
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [accessibilityLabel ? /*#__PURE__*/jsx("span", {
      className: styles.VisuallyHidden,
      children: accessibilityLabel
    }) : null, /*#__PURE__*/jsx("svg", {
      xmlns: XMLNS,
      "aria-hidden": true,
      width: width,
      height: height,
      children: data.map((series, index) => {
        const singleOffsetLeft = series.isComparison ? 0 : offsetLeft;
        const singleOffsetRight = series.isComparison ? 0 : offsetRight;
        const xScale = scaleLinear().range([singleOffsetLeft + SVG_MARGIN, width - singleOffsetRight - SVG_MARGIN]).domain([minXDomain, maxXDomain]);
        const seriesWithColor = {
          color: seriesColors[index],
          strokeDasharray: series.isComparison ? STROKE_DOT_ARRAY_WIDTH : 'none',
          ...series
        };
        return /*#__PURE__*/jsx("g", {
          children: /*#__PURE__*/jsx(LineSeries, {
            index: index,
            xScale: xScale,
            yScale: yScale,
            data: seriesWithColor,
            svgDimensions: {
              height,
              width
            },
            theme: theme,
            type: "spark"
          }, index)
        }, index);
      })
    })]
  });
}

export { Chart };
